
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSensorWaterEcGoogle as ObiSensorWaterEcGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sensor-water-ec-google.js';
 
 
 

 
 export const ObiSensorWaterEcGoogle = createComponent({
   react: React,
   tagName: 'obi-sensor-water-ec-google',
   elementClass: ObiSensorWaterEcGoogleElement,
   events: {
     
   }
  });
 
 